export function number(value) {
  return value !== undefined ? Number(value) : undefined;
}
export function array(value) {
  return (value || '').split(',').map(v => v.trim());
}
export function jsonFilter(filterString) {
  const jsonValue = {};
  const pairs = (filterString || '').split(',').filter(p => p);
  pairs.forEach(pair => {
    const [key, value] = pair.split(':');
    jsonValue[key] = decodeURIComponent(value);
  });
  return jsonValue;
}
export function searchFilter(json) {
  return Object.entries(json).map(([key, value]) => `${key}:${value}`).join(',');
}
export function parseFilter(filterString) {
  try {
    const s = decodeURIComponent(escape(window.atob(filterString)));
    return JSON.parse(s);
  } catch (_) {
    return [];
  }
}
export function stringifyFilter(filterString) {
  try {
    const s = unescape(encodeURIComponent(JSON.stringify(filterString)));
    return btoa(s);
  } catch (_) {
    return '';
  }
}
export function alias({
  resource,
  args,
  locale,
  body
}, appendBody, appendAll) {
  const aliasArgs = args || {};
  const argsString = resource !== 'search' ? Object.entries(aliasArgs).filter(([k, v]) => k !== 'page' && k !== 'pageSize' && v).sort(([aK], [bK]) => aK.localeCompare(bK)).map(([k, v]) => `${k}_${Array.isArray(v) ? v.map(vv => typeof vv === 'string' ? vv : JSON.stringify(vv)).join('_') : JSON.stringify(v)}`).join('_').normalize('NFD').replace(/-/g, '_').replace(/&/g, 'e').replace(/\|/g, 'o').replace(/[\u0300-\u036f]/g, '').replace(/[^\w ]+/g, '').replace(/ +/g, '_') : '';
  return `${locale ? `${locale}_` : ''}${resource}${argsString ? `_${argsString}` : ''}${appendBody && body ? `(${body})` : ''}${appendAll && (args.page || args.pageSize) ? `_pagging_${args.page}_${args.pageSize}` : ''}`;
}